"use strict";
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var colors_1 = require("./colors");
var overrideColors = {};
var callahanColors = __assign({}, colors_1.default, overrideColors);
exports.default = callahanColors;
//# sourceMappingURL=callahanColors.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/callahan-react/es/services/callahanColors.js
// module id = 99
// module chunks = 0